/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

import type { RoomMessageEventContent } from '../@types/events';
import { MsgType } from '../@types/event';

/**
 * Generates the content for a Plaintext Message event
 * @param text - the plaintext of the message
 * @returns The content for a Plaintext Message event
 */
export function makeTextMessage(text: string): RoomMessageEventContent {
  return {
    msgtype: MsgType.Text,
    text,
  };
}
